
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import moment, { Moment } from 'moment';
    import { Wait } from '@/__env/ext';
    import { Cliente } from '@/__env/lib/Clientes';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorInterfaz;

        public get Estado() { return this.Controlador.Vista.Estado; }

        public SeleccionarArchivo: boolean = false;
        public Archivo: File = null;

        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
                this.Iniciar();
        }

        public Iniciado: boolean = false;
        public Cargando: boolean = false;
        public Guardando: boolean = false;
        public Error: boolean = false;
        public Subiendo: boolean = false;

        public Ok()
        {
            return this.Archivo != null &&
                (
                    this.Archivo.name.endsWith( '.rar' ) ||
                    this.Archivo.name.endsWith( '.zip' ) ||
                    this.Archivo.name.endsWith( '.txt' ) ||
                    this.Archivo.name.endsWith( '.csv' )
                );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.$socket.client.off( 'up-padron-iibb-caba' );
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.$socket.client.on( 'up-padron-iibb-caba', this.Actualizar );
            this.Iniciar();
        }

        public async AgregarArchivo( archivo: File )
        {
            if ( !archivo )
                return;

            await Wait( 100 );
            this.Archivo = archivo;
        }

        async Iniciar()
        {
            this.ArchivoActual = null;
            this.Progreso = 0;
            this.Registros = 0;
            this.TotalRegistros = 0;
            this.Finalizando = false;
            this.Archivo = null;
            this.Cargando = false;
        }


        async Eliminar( c: any )
        {
            this.Archivo = null;
        }

        async Guardar()
        {
            this.Subiendo = true;
            let e = await Cliente.SubirPadron( this.Archivo, 'caba' );
            if ( e )
            {
                this.Cargando = true;
            } else
            {
                Utiles.Notificaciones.Error( 'Error al procesar el archivo!' );
                this.Error = true;
            }
            this.Subiendo = false;
        }

        /*PROGRESO*/
        public ArchivoActual: string = '';
        public Progreso: number = 0;
        public Registros: number = 0;
        public TotalRegistros: number = 0;
        public Finalizando: boolean = false;

        async Actualizar( e: any )
        {
            if ( e.end )
            {
                this.Iniciar();
                Utiles.Notificaciones.Completado( 'Padrón completado!' );
            }
            else if ( e.finalizando )
            {
                this.Finalizando = true;
            } else
            {
                this.Cargando = true;
                this.ArchivoActual = e.archivo;
                this.Progreso = e.progreso;
                this.Registros = e.registros;
                this.TotalRegistros = e.total;
            }

        }

    }
